import jsPDF from 'jspdf';
import { CommonUtils } from '@infodata-group/inf-commons';

export class PdfHelper {
  public static setFillColor(doc: jsPDF, color?: string) {
    if (color) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      const a = parseInt(color.slice(7, 9), 16);
      doc.setFillColor(r, g, b);
    } else {
      doc.setFillColor(CommonUtils.color('black'));
    }
  }

  public static generateTextLine(
    doc: jsPDF,
    text: string,
    width: number,
    height: number,
  ) {
    let textLines: string[] = doc.splitTextToSize(text, width);
    const fontSize = doc.getFontSize();
    const lineHeight = doc.getLineHeight();
    const oneLineHeight = fontSize + 4;
    const textHeight = textLines.length * oneLineHeight;
    const maxHeight = Math.floor(height / oneLineHeight);
    if (textHeight > height) {
      textLines = textLines.slice(0, maxHeight);
      const lastLine = textLines[textLines.length - 1];
      textLines[textLines.length - 1] = lastLine + ' ...';
    }
    return textLines;
  }
}
